module.exports = "/images/run-better-promotions.svg?957d2b4cfc2a8a627ecc5c5a45363c83";